"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _BouncerProvider = _interopRequireDefault(require("@/libs/BouncerProvider"));
var _Captcha = _interopRequireDefault(require("@/components/Captcha"));
var _CommonLayout = _interopRequireDefault(require("./CommonLayout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let log = _Logger.default.namespace('Welcome.vue');
var _default = exports.default = {
  components: {
    Captcha: _Captcha.default,
    StartupLayout: _CommonLayout.default
  },
  data() {
    return {
      connectErrors: [],
      network: null,
      channel: '',
      nick: '',
      password: '',
      showChannel: true,
      showPass: true,
      toggablePass: true,
      showNick: true,
      show_password_box: false,
      connectWithoutChannel: false,
      showPlainText: false,
      captchaReady: false,
      termsAccepted: false
    };
  },
  computed: {
    isIframe() {
      return !(window === window.parent || window.opener);
    },
    startupOptions() {
      return this.$state.settings.startupOptions;
    },
    greetingText() {
      let greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    footerText() {
      let footer = this.$state.settings.startupOptions.footerText;
      return typeof footer === 'string' ? footer : '';
    },
    termsContent() {
      let terms = this.$state.settings.startupOptions.termsContent;
      return typeof terms === 'string' ? terms : '';
    },
    buttonText() {
      let greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    },
    isNickValid() {
      let nickPatternStr = this.$state.setting('startupOptions.nick_format');
      let nickPattern = '';
      if (!nickPatternStr) {
        // Nicks cannot start with [0-9- ]
        // ? is not a valid nick character but we allow it as it gets replaced
        // with a number.
        nickPattern = /^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i;
      } else {
        // Support custom pattern matches. Eg. only '@example.com' may be allowed
        // on some IRCDs
        let pattern = '';
        let flags = '';
        if (nickPatternStr[0] === '/') {
          // Custom regex
          let pos = nickPatternStr.lastIndexOf('/');
          pattern = nickPatternStr.substring(1, pos);
          flags = nickPatternStr.substr(pos + 1);
        } else {
          // Basic contains rule
          pattern = _lodash.default.escapeRegExp(nickPatternStr);
          flags = 'i';
        }
        try {
          nickPattern = new RegExp(pattern, flags);
        } catch (error) {
          log.error('Nick format error: ' + error.message);
          return false;
        }
      }
      return this.nick.match(nickPattern);
    },
    readyToStart() {
      let ready = !!this.nick;
      if (!this.connectWithoutChannel && !this.channel) {
        ready = false;
      }

      // Make sure the channel name starts with a common channel prefix
      if (!this.connectWithoutChannel) {
        let bufferObjs = Misc.extractBuffers(this.channel);
        bufferObjs.forEach(bufferObj => {
          if ('#&'.indexOf(bufferObj.name[0]) === -1) {
            ready = false;
          }
        });
      }

      // If toggling the password is is disabled, assume it is required
      if (!this.toggablePass && !this.password) {
        ready = false;
      }
      if (!this.isNickValid) {
        ready = false;
      }
      if (this.termsContent && !this.termsAccepted) {
        ready = false;
      }
      return ready;
    }
  },
  watch: {
    show_password_box(newVal) {
      if (newVal === false) {
        // clear the password when show password is unchecked
        this.password = '';
      }
    }
  },
  created() {
    let options = this.startupOptions;
    let connectOptions = this.connectOptions();

    // Take some settings from a previous network if available
    let previousNet = null;
    if (connectOptions.hostname.trim()) {
      previousNet = this.$state.getNetworkFromAddress(connectOptions.hostname.trim());
    }
    if (previousNet && previousNet.connection.nick) {
      this.nick = previousNet.connection.nick;
    } else if (Misc.queryStringVal('nick')) {
      this.nick = Misc.queryStringVal('nick');
    } else {
      this.nick = options.nick;
    }
    this.nick = this.processNickRandomNumber(this.nick || '');
    if (options.password) {
      this.password = options.password;
    } else if (previousNet && previousNet.password) {
      this.password = previousNet.password;
      this.show_password_box = true;
    } else {
      this.password = '';
    }
    this.channel = decodeURIComponent(window.location.hash) || options.channel || '';
    this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
    this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
    this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
    this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;
    this.connectWithoutChannel = !!options.allowNoChannel;
    if (options.bouncer) {
      this.toggablePass = false;
      this.showPass = true;
      this.showChannel = false;
      this.connectWithoutChannel = true;
      let bouncer = new _BouncerProvider.default(this.$state);
      bouncer.enable(connectOptions.hostname, connectOptions.port, connectOptions.tls, connectOptions.direct, connectOptions.direct_path);
    }
    if (options.autoConnect && this.readyToStart) {
      this.startUp();
    }
  },
  methods: {
    onAltClose(event) {
      if (event.channel) {
        this.channel = event.channel;
      }
      if (event.nick) {
        this.nick = event.nick;
      }
      if (event.password) {
        this.password = event.password;
      }
      if (event.error) {
        this.connectErrors.push(event.error);
      }
      this.$state.settings.startupOptions.altComponent = null;
    },
    readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    formSubmit() {
      if (this.readyToStart) {
        this.startUp();
      }
    },
    startUp() {
      this.connectErrors = [];
      let options = Object.assign({}, this.$state.settings.startupOptions);
      let connectOptions = this.connectOptions();
      let netAddress = _lodash.default.trim(connectOptions.hostname);

      // Check if we have this network already
      let net = this.network || this.$state.getNetworkFromAddress(netAddress);
      let password = this.password;

      // If the network doesn't already exist, add a new one
      net = net || this.$state.addNetwork('Network', this.nick, {
        server: netAddress,
        port: connectOptions.port,
        tls: connectOptions.tls,
        password: password,
        encoding: _lodash.default.trim(options.encoding),
        direct: connectOptions.direct,
        path: connectOptions.direct_path || '',
        gecos: options.gecos,
        username: options.username
      });

      // Clear the server buffer in case it already existed and contains messages relating to
      // the previous connection, such as errors. They are now redundant since this is a
      // new connection.
      net.serverBuffer().clearMessages();

      // If we retreived an existing network, update the nick+password with what
      // the user has just put in place
      net.connection.nick = this.nick;
      if (options.bouncer) {
        // Bouncer mode uses server PASS
        net.connection.password = `${this.nick}:${password}`;
        net.password = '';
      } else {
        net.connection.password = '';
        net.password = password;
      }
      if (_lodash.default.trim(options.encoding || '')) {
        net.connection.encoding = _lodash.default.trim(options.encoding);
      }
      this.network = net;

      // Only switch to the first channel we join if multiple are being joined
      let hasSwitchedActiveBuffer = false;
      let bufferObjs = Misc.extractBuffers(this.channel);
      bufferObjs.forEach(bufferObj => {
        let newBuffer = this.$state.addBuffer(net.id, bufferObj.name);
        newBuffer.enabled = true;
        if (newBuffer && !hasSwitchedActiveBuffer) {
          this.$state.setActiveBuffer(net.id, newBuffer.name);
          hasSwitchedActiveBuffer = true;
        }
        if (bufferObj.key) {
          newBuffer.key = bufferObj.key;
        }
      });

      // switch to server buffer if no channels are joined
      if (!options.bouncer && !hasSwitchedActiveBuffer) {
        this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
      }
      net.ircClient.connect();
      let onRegistered = () => {
        if (this.$refs.layout) {
          this.$refs.layout.close();
        }
        net.ircClient.off('registered', onRegistered);
        net.ircClient.off('close', onClosed);
        net.ircClient.off('irc error', onError);
      };
      let onClosed = () => {
        var _context;
        let lastError = this.network.last_error;
        if (lastError && !(0, _includes.default)(_context = this.connectErrors).call(_context, lastError)) {
          this.connectErrors.push(lastError);
        }
        net.ircClient.off('registered', onRegistered);
        net.ircClient.off('close', onClosed);
        net.ircClient.off('irc error', onError);
      };
      let onError = event => {
        var _context2;
        if (!event.reason || (0, _includes.default)(_context2 = this.connectErrors).call(_context2, event.reason)) {
          return;
        }
        this.connectErrors.push(event.reason);
      };
      net.ircClient.once('registered', onRegistered);
      net.ircClient.once('close', onClosed);
      net.ircClient.on('irc error', onError);
    },
    processNickRandomNumber(nick) {
      // Replace ? with a random number
      let tmp = (nick || '').replace(/\?/g, () => Math.floor(Math.random() * 100).toString());
      return _lodash.default.trim(tmp);
    },
    handleCaptcha(isReady) {
      this.captchaReady = isReady;
    },
    connectOptions() {
      let options = Object.assign({}, this.$state.settings.startupOptions);
      let connectOptions = Misc.connectionInfoFromConfig(options);

      // If a server isn't specified in the config, set some defaults
      // The webircgateway will have a default network set and will connect
      // there instead. This just removes the requirement of specifying the same
      // irc network address in both the server-side and client side configs
      connectOptions.hostname = connectOptions.hostname || 'default';
      if (!connectOptions.port && connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 443 : 80;
      } else if (!connectOptions.port && !connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 6697 : 6667;
      }
      return connectOptions;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Welcome"]
window._kiwi_exports.components.startups.Welcome = exports.default ? exports.default : exports;
